import React from "react";
import { createRoot } from "react-dom/client";
import Dagonet from "../components/Dagonet.jsx";

const root = createRoot(document.getElementById("root"));
root.render(<Dagonet />);
